
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/debtreliefcorner/contact-us",
      function () {
        return require("private-next-pages/debtreliefcorner/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/debtreliefcorner/contact-us"])
      });
    }
  